import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo6/fiestas.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 2.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[1];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[2].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[2].path}`,
    titlePrev: `${modulo6.content[0].activities[0].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>Observa la imagen y responde las preguntas.</li>
      </ul>

      <img src={Imagen1} alt="Familia" className="img-fluid mb-5" />
      <div className="col-lg-8 col-12 mb-0">
        <p>¿Qué símbolo nacional observas en distintas partes de la imagen?</p>
        <textarea className="form-control mt-1 mb-4" rows={3} />
        <p>
          ¿Por qué crees que en todos los edificios y hasta en los barcos está
          la bandera peruana?
        </p>
        <textarea className="form-control mt-1 mb-4" rows={3} />
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y las preguntas. Pida que describan la imagen.
          Ayude a responder: en la imagen se observan banderas porque
          seguramente es época de Fiestas Patrias.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
